<report class="full-height report" [orientation]="'landscape'" title="Muckpile Report">
    <ng-container pages>
        <report-page-title ngProjectAs="report-page" title="Muckpile Report">
        </report-page-title>
        <ng-container ngProjectAs="report-page">
            <report-page [footer]="true" class="landscape">
                <div class="full-width muckpile-map">
                    <div #map class="full-height full-width"></div>
                </div>
            </report-page>
        </ng-container>
        <ng-container ngProjectAs="report-page">

            <report-page [footer]="true" class="landscape">
                <div class="centered-content chart-header">
                    <caption class="mt-1 text-underline font-bold chart-title imported-title">Imported Muckpile Fragmentation</caption>
                </div>
                <button mat-flat-button
                    *ngIf="isCustomSizeEnabled(device$ | async) && ((muckpileData$ | async)?.imported_fragmentation) && (muckpileData$ | async)?.imported_fragmentation?.psd?.length !== 0"
                    class="off-sepc" [ngClass]="isImportedOffSpec ? 'off-spec-true' : 'off-spec-false'">
                    {{ isImportedOffSpec ? 'On' : 'Off'}} Spec</button>
                <div *ngIf="!(muckpileData$ | async)" class="container centered-content">
                    <mat-spinner *ngIf="(muckpileData$ | async) === undefined" strokeWidth="3"
                        [diameter]="50"></mat-spinner>
                    <div *ngIf="(muckpileData$ | async) === null" class="container centered-content">
                        <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                        <div>No Data Found</div>
                    </div>
                </div>
                <div *ngIf="(muckpileData$ | async)?.imported_fragmentation as importedFragment">
                    <div *ngIf="importedFragment">
                        <psd-chart [index]="0" [muckpileData]="importedFragment" [type]="'muckpile'"
                            (offSpecEmitter)="setImportedOffSpec($event)"></psd-chart>
                    </div>
                </div>
                <div *ngIf="(muckpileData$ | async)?.imported_fragmentation?.psd?.length === 0"
                    class="container centered-content">
                    <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                    <div>No Data Imported</div>
                </div>
                <div *ngIf="(muckpileData$ | async)?.imported_fragmentation as importedFragment"
                    class="table-container mt-20">
                    <mat-card class="full-width container">
                        <div *ngIf="!(muckpileData$ | async)" class="container centered-content full-width half-height">
                            <mat-spinner *ngIf="(muckpileData$ | async) === undefined" strokeWidth="3"
                                [diameter]="50"></mat-spinner>
                            <div *ngIf="(muckpileData$ | async) === null" class="container centered-content">
                                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                <div>No Data Found</div>
                            </div>
                        </div>
                        <muckpile-statistics [details]="(muckpileData$ | async)?.details" [areaUnit]="areaUnit$ | async"
                            [particleSizeUnit]="particleSizeUnit$ | async">
                        </muckpile-statistics>
                    </mat-card>
                </div>
            </report-page>
        </ng-container>
        <ng-container ngProjectAs="report-page">
            <report-page [footer]="true" class="landscape">
                <div class="psd-chart-container"
                    *ngIf="(muckpileData$ | async)?.actual_fragmentation as actualFragment">
                    <div *ngIf="isEmptyObject(actualFragment) && ((graph$ | async) === 'tagged')"
                        class="container centered-content">
                        <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                        <div>No Intervals/Dumps Tagged</div>
                    </div>
                    <div class="chart-content" *ngIf="!isEmptyObject(actualFragment)">
                        <div class="centered-content chart-header">
                            <caption class="mt-1 text-underline font-bold chart-title">Tagged Data Fragmentation</caption>
                        </div>
                        <button mat-flat-button *ngIf="isCustomSizeEnabled(device$ | async)" class="off-sepc"
                            [ngClass]="isActualOffSpec ? 'off-spec-true' : 'off-spec-false'">{{ isActualOffSpec ? 'On' : 'Off'}} Spec
                        </button>
                        <psd-chart [index]="0" [muckpileData]="actualFragment" [type]="'muckpile'"
                            (offSpecEmitter)="setActualOffSpec($event)"></psd-chart>
                    </div>
                </div>
            </report-page>
        </ng-container>
    </ng-container>
</report>